export var BoilerAdapterProcessor;
(function (BoilerAdapterProcessor) {
    BoilerAdapterProcessor[BoilerAdapterProcessor["UNKNOWN"] = 0] = "UNKNOWN";
    BoilerAdapterProcessor[BoilerAdapterProcessor["F070"] = 1] = "F070";
    BoilerAdapterProcessor[BoilerAdapterProcessor["L052"] = 2] = "L052";
    BoilerAdapterProcessor[BoilerAdapterProcessor["L031"] = 3] = "L031";
    BoilerAdapterProcessor[BoilerAdapterProcessor["G031"] = 4] = "G031";
    BoilerAdapterProcessor[BoilerAdapterProcessor["AT421"] = 5] = "AT421";
    BoilerAdapterProcessor[BoilerAdapterProcessor["UNKNOWN2"] = 255] = "UNKNOWN2";
})(BoilerAdapterProcessor || (BoilerAdapterProcessor = {}));
const translationBoilerAdapterProcessor = {
    [BoilerAdapterProcessor.UNKNOWN]: 'Неизвестно',
    [BoilerAdapterProcessor.F070]: 'F070',
    [BoilerAdapterProcessor.L052]: 'L052',
    [BoilerAdapterProcessor.L031]: 'L031',
    [BoilerAdapterProcessor.G031]: 'G031',
    [BoilerAdapterProcessor.AT421]: 'AT421',
    [BoilerAdapterProcessor.UNKNOWN2]: 'Неизвестно',
};
export function translateBoilerAdapterProcessor(processor) {
    return translationBoilerAdapterProcessor[processor] ?? `Неизвестный: ${processor}`;
}
